// extracted by mini-css-extract-plugin
export default {"wrapperComponent":"Status_wrapperComponent__1P35p","message":"Status_message__vebbT"};